var _rect, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3320 -911C-3320 -912.105 -3319.1 -913 -3318 -913H5905C5906.1 -913 5907 -912.105 5907 -911V5106C5907 5107.1 5906.1 5108 5905 5108H-3318C-3319.1 5108 -3320 5107.1 -3320 5106V-911Z",
    fill: "#ECF5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3318 -912H5905V-914H-3318V-912ZM5906 -911V5106H5908V-911H5906ZM5905 5107H-3318V5109H5905V5107ZM-3319 5106V-911H-3321V5106H-3319ZM-3318 5107C-3318.55 5107 -3319 5106.55 -3319 5106H-3321C-3321 5107.66 -3319.66 5109 -3318 5109V5107ZM5906 5106C5906 5106.55 5905.55 5107 5905 5107V5109C5906.66 5109 5908 5107.66 5908 5106H5906ZM5905 -912C5905.55 -912 5906 -911.552 5906 -911H5908C5908 -912.657 5906.66 -914 5905 -914V-912ZM-3318 -914C-3319.66 -914 -3321 -912.657 -3321 -911H-3319C-3319 -911.552 -3318.55 -912 -3318 -912V-914Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12066_18521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1194 -360)",
    fill: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1114 -360H246V664H-1114V-360Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12066_18521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1077 -172C-1077 -174.761 -1074.76 -177 -1072 -177H207C209.761 -177 212 -174.761 212 -172V593C212 595.761 209.761 598 207 598H-1072C-1074.76 598 -1077 595.761 -1077 593V-172Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1057.5,
    y: -72.5,
    width: 1253,
    height: 107,
    stroke: "#DADADA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_12066_18521",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-86 -17H196V34H-86V-17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-86 -17H196V34H-86V-17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 -17V34H197V-17H195Z",
    fill: "#DADADA",
    mask: "url(#path-6-inside-1_12066_18521)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12066_18521",
    x: -1089,
    y: -181,
    width: 1313,
    height: 799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12066_18521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12066_18521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12066_18521",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12066_18521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1194 -360)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12066_18521",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACY0lEQVR4nO2bXUrDUBgF7zrSLEK344tUmo8bN+Cr+y42gn9IaAuiZs797hnIgz7IeMZUTdJSjDHGmI2JcV5aPKaxHmOo9yUb9LDxu+MUw1xLJgRGXRwlV5Al1Zmy/uaKOJE9SqIgS4oorQeZxvqy/nga60NpldaDxDjv11GaPlNaD1LeP5cnSoYgqaJkCZImSqYgKaJkC9J8lIxBmo6SNUizUTIHaTJK9iDNRekhSFNRegnSTJSegjQRpbcg8lF6DCIdpdcgslF6DiIZpfUg8U/HWyTiuS8Hma9FOTqIyBmCvWLgAj/EQToj6B9QXEAMfA9cQAx8D1xADHwPXEAMfA9cQAx8D1xADHwPXEAMfA9cQAx8D1xADHwPXOAKh+HxpvS2By5wgWk3PxP3JfA9cIHLMT6dNo2C74ELrKhDvSXfpobvgQuI3VbF98AFxKLge+ACYlHwPXABsSj4HriAWBR8D1xALAq+By4gFgXfAxcQi4LvgQuIRcH3wAXEouB7/LXA+uvFxsdHpL3KHqX3IPEVpd4p7IEL0DHCQbSCTH7JYgj/Utch/GevDuF/DHUIXzrRIXxxUYfw5XcdwjeodAjfwtW5uBh+yAG6dnMGPwZEXkxb4Qfl6KubZ4jd/PTNyY+SCkU5+WFrIQ5+O4LGSxYJ/hKOC4iB74ELiIHvgQuIge+BC4iB74ELiIHvgQuIge+BC4iB74ELiIHvgQuIge+BC4iB74ELiIHvgQuIge+BC4iB74ELiIHvgQuIge+BC4iB74ELiIHvsRbwMTtICP8g+AwZ+QgOMvLDywQxxhhTeucV9kN0epjA5GQAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.1169249faf281179f51e88963a51c698.svg";
export { ForwardRef as ReactComponent };